import React from "react";
import { IconX } from "../../icons/Icon";
import "../../assets/styles/btn-close.scss";
import { COLOR_PRIMARY } from "../../constants/colors";

const BtnClose = ({ control }) => {
  return (
    <button
      type="button"
      className="smu-btn-close shadow"
      onClick={() => control()}
    >
      <IconX color={COLOR_PRIMARY} />
    </button>
  );
};

export default BtnClose;
